import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../api/baseurl";
import "./a4shett.css";
import tmplLogo from "../images/tmplLogo.png";
import "./Spinner.css";

function Payment() {
  const [packages, setPackages] = useState(null);
  const [testDetails, setTestDetails] = useState([]);
  const [order, setOrder] = useState({});
  const [data, setdata] = useState(null);
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const appointmentData = location.state;

const packageId = appointmentData?.packageId || null;
const userid = appointmentData?.userid;
const additionalTestIds = appointmentData?.additionalTestIds || [];

  const razorpayKey = process.env.REACT_APP_RAZORPAY_KEY;
  const razorpaySecret = process.env.REACT_APP_RAZORPAY_SECRET;

  const token = JSON.parse(localStorage.getItem("data")).token;
  const userRole = JSON.parse(localStorage.getItem("data")).role;
  const date = new Date();

  let day = date.getDate();
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let year = date.getFullYear();
  let currentDate = `${day}-${month}-${year}`;

  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmp = async () => {
      try {
        const res = await axios.get(
          `/api/employeedetails/userid=${userid}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
        setdata(res.data);
      } catch (error) {
        console.error("Error fetching employee details:", error);
        toast.error("Failed to fetch employee details");
      }
    };

    fetchEmp();
  }, [userid]);

  const getData = async () => {
  try {
    setLoading(true);

    // ✅ Fetch package details
    if(packageId!==null){
    const response = await axios.get(`/api/package/${packageId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setPackages(response.data);
  }

    // ✅ Fetch all additional test details (if any)
    if (additionalTestIds && additionalTestIds.length > 0) {
      const testRequests = additionalTestIds.map((id) =>
        axios.get(`/api/labtest/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
      );

      // Wait for all requests to finish
      const testResponses = await Promise.all(testRequests);

      // Collect all test details
      const allTests = testResponses.map((res) => res.data);

      setTestDetails(allTests);
      console.log("All test details:", allTests);
    } else {
      setTestDetails([]);
    }

    setLoading(false);
  } catch (error) {
    console.error("Error fetching data:", error);
    toast.error("Failed to fetch package or test details");
    setLoading(false);
  }
};

  useEffect(() => {
    getData();
  }, []);

const totalTestCost = testDetails.reduce(
  (sum, test) => sum + (test?.testCost?.cost || 0),
  0
);

const packagePrice = packages?.price || 0;
const price = parseFloat(packagePrice + totalTestCost);

  const gstRate = 0.0;
  const platformFeeRate = 0.03;
  const platformGstRate = 0.18;

  const cgst = (price * gstRate) / 2;
  const sgst = (price * gstRate) / 2;
  const cost = (price + cgst + sgst);
  const platformFee = cost * platformFeeRate;
  const platformFeeGst = platformFee * platformGstRate;
  const totalPlatformFee = platformFee + platformFeeGst;

  const totalTransactionCost = price + cgst + sgst + platformFee + platformFeeGst;

  const handlePayment = async (e, totalamount) => {
    e.preventDefault();
    setLoading(true);
    const amountInPaise = Math.round(totalamount * 100);
    const orderId = order.orderId;

    try {
      const response = await axios.post('/api/payment/createOrder', {
        amount: totalamount,
        currency: 'INR',
        userid: userid,
        memberid: appointmentData?.familyid ? appointmentData?.familyid : null,
        companyId: data?.companyId,
        appointmentDate: appointmentData?.appointmentDate,
        labId: appointmentData?.labId,
        packageId: packageId,
        // additionalTestId: additionalTestId || null,
        platformFee: totalPlatformFee
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      const orderData = response.data;
      setOrder(orderData);
      if (window.Razorpay) {
        var options = {
          key: razorpayKey,
          key_secret: razorpaySecret,
          amount: amountInPaise,
          currency: "INR",
          name: "cynefian",
          order_id: response.data.orderId,
          description: "for testing purpose",
          handler: function (response) {
            console.log(response, "aaa");
            localStorage.setItem('razorpay_payment_id', response.razorpay_payment_id);
            var values = {
              razorpay_payment_id: response.razorpay_payment_id,
              amount: totalamount,
              paymentStatus: response.paymentStatus,
              currency: "INR",
              razorpay_order_id: response.razorpay_order_id,
              userid: userid,
              companyId: data?.companyId
            };

            var appointment = {
              entity: {
                familyid: appointmentData?.familyid ? appointmentData?.familyid : null,
                date: appointmentData?.appointmentDate,
                labId: appointmentData?.labId,
                packageid: packageId,
                additionalTest: additionalTestIds.map((id) => ({ testId: id })),
                userid: userid,
              },
              payment: {
                username: data?.email,
                id: response.id,
                razorpay_payment_id: response.razorpay_payment_id,
                amount: totalamount,
                paymentStatus: response.paymentStatus,
                currency: "INR",
                razorpay_order_id: response.razorpay_order_id,
                userid: userid,
                companyId: data?.companyId,
                platformFee: totalPlatformFee
              },
            };
            axios.post(`/api/employeeappointment/createAppointmentWithPayment`, appointment, {
              headers: {
                Authorization: `Bearer ${token}`
              }
            })
              .then((appointmentRes) => {
                axios.post(`/api/payment/processPayment`, values, {
                  headers: {
                    Authorization: `Bearer ${token}`
                  }
                })
                  .then((paymentRes) => {
                    setLoading(false);
                    
                    navigate(`/users/payment-reference`, { state: appointmentData });
                    toast.success("Payment successful and appointment booked successfully");
                  })
                  .catch((paymentErr) => {
                    setLoading(false);
                    toast.error("Payment processing failed. Please try again.");
                  });
              })
              .catch((appointmentErr) => {
                setLoading(false);
                toast.error("Appointment booking failed. Please try again.");
              });
          }
        };

        const pay = new window.Razorpay(options);
        pay.open();
      } else {
        toast.error('Razorpay script not loaded');
      }
    } catch (error) {
      setLoading(false);
      toast.error("Payment initiation failed");
    }
  };

  const handleClose = async (e, memberid) => {
    e.preventDefault();
    if (memberid !== null && memberid!==undefined) {
      navigate(`/users/family-profile/${memberid}`);
    } else if (userRole === 'ROLE_EMPLOYEE') {
      navigate(`/users/employee-appointments`)
    } else {
      navigate(`/users/employee-profile/${userid}`);
    }
  };

  if (loading || !data) {
    return (
      <div>
        <div className="loading"></div>
      </div>
    );
  }

  return (
    <div>
      <div id="layoutDrawer_content">
        <main>
          <div className="a4-sheet">
            <header className="bg-primary">
              <div className="container-xl px-5">
                <h1 className="text-white py-3 mb-0 display-6"></h1>
              </div>
            </header>

            <div className="container mt-5">
              <form>
                <div>
                  {/* Company Header */}
                  <div className="row mb-4">
                    <div className="col-md-6">
                      <h6><b>Timespan pvt ltd.</b></h6>
                      <h6>Bangalore, Karnataka</h6>
                      <h6>PIN</h6>
                      <h6>GSTIN- 29AAJCC7045D1ZM</h6>
                    </div>
                    <div className="col-md-6 text-end">
                      <img src={tmplLogo} width="125px" height="70px" alt="TMPL Logo" />
                    </div>
                  </div>

                  {/* Recipient Details */}
                  <div className="mb-4">
                    <h6><b>To</b></h6>
                    <h6>{data?.email}</h6>
                    <h6>{data?.address}</h6>
                    <h6>PAN-{data?.pan}</h6>
                  </div>

                  <hr style={{ height: "8px", color: "black" }} />

                  {/* Total Amount Header */}
                  <div className="row mb-3">
                    <div className="col-6">
                      <h2>Total Amount</h2>
                    </div>
                    <div className="col-6 text-end">
                      <h2>{totalTransactionCost.toFixed(2)} ₹</h2>
                    </div>
                  </div>

                  <hr style={{ height: "8px", backgroundColor: "black" }} />

                  {/* Price Breakdown */}
                  <div className="row mb-4">
                    <div className="col-md-6 offset-md-6">
                      <div className="ms-5">
                        {packageId ? (
                          <>
                        <h6>Package Price: {packagePrice.toFixed(2)}</h6>
                        {additionalTestIds.length >0 && (
                          <>
                          <h6>Additional Test Cost: {totalTestCost.toFixed(2)}</h6>
                           <h6>Subtotal: {price.toFixed(2)}</h6>
                           </>
                        )}
                        
                        </>
                      ):(
                        <h6>Amount: {totalTestCost.toFixed(2)}</h6>
                      )}
                       
                        <h6>CGST: {cgst.toFixed(2)}</h6>
                        <h6>SGST: {sgst.toFixed(2)}</h6>
                        <h6>Platform Fee: {totalPlatformFee.toFixed(2)}</h6>
                        <h2 style={{ color: "black" }} className="mt-3">
                          Total Amount: {totalTransactionCost.toFixed(2)} ₹
                        </h2>
                      </div>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="row mt-5">
                    <div className="col-12 text-end">
                      <button
                        onClick={(e) => handleClose(e, appointmentData?.familyid)}
                        className="btn btn-secondary me-3"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={(e) => handlePayment(e, totalTransactionCost)}
                        className="btn btn-primary"
                      >
                        Proceed
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Payment;